import { render, staticRenderFns } from "./PastesCreate.vue?vue&type=template&id=da6b7de2&scoped=true"
import script from "./PastesCreate.vue?vue&type=script&lang=js"
export * from "./PastesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6b7de2",
  null
  
)

export default component.exports